<template>
    <AppNavigation>
        <mdb-container fluid>
            <h1 class="h1-responsive">Active Orders</h1>
            <hr>
            <mdb-row>
                <mdb-col col="12">
                    <div id="map" />
                </mdb-col>
            </mdb-row>
            <p class="text-danger">This map cost google map API. $14 per 1000 requests</p>
        </mdb-container>
    </AppNavigation>
</template>

<script>
// @ is an alias to /src
import {mdbContainer, mdbCol, mdbRow} from 'mdbvue';
import AppNavigation from '../components/AppNavigation';
import {ajax} from '../js/ajax';
// import {APP_FILE_URL} from '../js/config';

export default {
  name: 'active_orders',
  components: {
    mdbContainer, mdbCol, mdbRow,
    AppNavigation,
  },
  data: ()=>({
      orders:[],
      map:null,
  }),
  methods: {
    getData(){
        this.loading=true;
        ajax({
            url: "admin/get_active_orders",
            complete: ()=>this.loading=false,
            success: result=>{
                this.orders=result.data.jobs;
                this.renderMap();
            },
            fail: fail=>this.$notify.error({message: fail.message, position: 'top right', timeOut: 5000})
        })
    },
    renderMap(){
        const google = window.google;
        if(this.map==null){
            var mapProp = {
                center:new google.maps.LatLng(2.2764785,102.8828676),
                zoom:8,
            };
            this.map=new google.maps.Map(document.getElementById("map"),mapProp);
            this.orders.forEach(element => {
                let merchant_point = new google.maps.LatLng(element.lat,element.lng);
                var merchant_marker = new google.maps.Marker({
                    position: merchant_point,
                    title:element.service_order.merchant.name,
                    animation: google.maps.Animation.DROP,
                });
                merchant_marker.setIcon('https://maps.google.com/mapfiles/ms/icons/blue-dot.png')

                let customer_point = new google.maps.LatLng(element.deliver_lat,element.deliver_lng);
                var customer_marker = new google.maps.Marker({
                    position: customer_point,
                    title:element.service_order.customer_user.name,
                    animation: google.maps.Animation.DROP,
                });
                customer_marker.setIcon('https://maps.google.com/mapfiles/ms/icons/green-dot.png')
                
                google.maps.event.addListener(merchant_marker, 'click', ()=>{
                    sessionStorage.setItem('order_number', element.service_order.order_number);
                    this.$router.replace({ name: "orders" })
                });
                google.maps.event.addListener(customer_marker, 'click', ()=>{
                    sessionStorage.setItem('order_number', element.service_order.order_number);
                    this.$router.replace({ name: "orders" })
                });
                customer_marker.setMap(this.map);
                merchant_marker.setMap(this.map);
                
                //render Direction
                var directionsService = new google.maps.DirectionsService();
                var directionsDisplay = new google.maps.DirectionsRenderer();
                directionsDisplay.setMap(this.map);
                directionsDisplay.setOptions( { suppressMarkers: true } );
                var request = {
                    origin: customer_point, 
                    destination: merchant_point,
                    travelMode: google.maps.DirectionsTravelMode.DRIVING
                };
                
                directionsService.route(request, function(response, status) {
                    if (status == google.maps.DirectionsStatus.OK) {
                        directionsDisplay.setDirections(response);
                    }
                });
            });
        }
    }
  },
  mounted: function(){
    // this.getData();
  }
}
</script>
<style scoped>
#map{
    width: 100%;
    height: 70vh;
}
</style>